module.exports = __webpack_public_path__ + "img/currencyEle.d0212029.svg";